VjsAdmin.GoogleSyncQueue = (function () {
    const me = {};

    me.$table = $('#google-queue-table');
    me.platform_id = me.$table.attr('data-platform-id');
    me.district_joint_guid = me.$table.attr('data-district-joint-guid');
    // quit polling the server if too many errors happen
    me.polling_error = 0;
    me.polling_error_threshold = 2;
    me.polling_timeout = null;

    // amount of time between refreshing the table
    me.polling_interval = 4000;

    me.$queue_sync_modal = null;

    me.init = function () {
        me.initTable();

        SafeDOM.registerQueueResultsPopup(me);

        SafeDOM.registerQueueSync(me, 'platforms.districts.google.queue.add');
    };

    me.initTable = function () {
        me.$table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#google-queue-table',
            formatNoMatches() {
                return 'No Google History (...yet)';
            },
            idField: 'id',
            sortName: 'created_at',
            sortOrder: 'DESC',
            search: false,
            url: Slim.Router.pathFor('platforms.districts.google.queue.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
            }),
            ...SafeDOM.makeQueueTableCallbacks(me),
            columns: [
                [
                    {
                        title: 'Status',
                        field: 'status',
                        align: 'center',
                        class: 'status',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'ID',
                        field: 'id',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Queued',
                        field: 'created_at',
                        align: 'left',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Started',
                        field: 'date_started',
                        align: 'left',
                        valign: 'middle',
                        sortable: false,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Action',
                        field: 'date_last_action',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Finished',
                        field: 'date_finished',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Mode',
                        field: 'mode',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Users',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 6,
                    },
                    {
                        title: 'Errors',
                        field: 'number_of_errors',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Action',
                        field: 'actions',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        rowspan: 2,
                    },
                ],
                SafeDOM.getQueueUsersSubColumns(),
            ],
            responseHandler: SafeDOM.makeDistrictQueueResponseHandler({
                rowIdField: 'id',
                hasClassesRow: false,
                cancelPermission: 'platforms.districts.google.queue.cancel',
                cancelRoute: 'platforms.districts.google.queue.cancel',
                logPermission: 'platforms.districts.google.queue.log',
                logRoute: 'platforms.districts.google.queue.log',
            }),
        });
    };

    return {
        init: me.init,
    };
}());
